module.exports = __webpack_public_path__ + "img/chat.2d2b6ff6.gif";